/* Polite Society product card — swatch → image swap + link update.

   Colourways in this catalogue are separate products (lolita-slip-dress-green,
   lolita-slip-dress-black …) that each list every colour in their COLOUR option,
   so a swatch usually has no variant image to show. When that happens we resolve
   the sibling product by handle and take its featured image and URL. */
(function () {

  /* The size row is rendered for one colour (the active swatch). When another
     swatch is picked, re-point it from that colour's own in-stock sizes, so a
     size that only exists in a different colourway stops reading as available.

     An empty or missing list means "not known for this colour" — several
     colourways are separate products, whose sizes only arrive with the sibling
     fetch below — so the row is left alone rather than struck out wholesale. */
  function applySizesFromList(card, raw) {
    if (!card || !raw) return;
    if (raw === '~none~') {
      /* the colour exists here and is sold out in every size */
      card.querySelectorAll('[data-size]').forEach(function (el) { el.classList.add('is-disabled'); });
      return;
    }
    var inStock = {};
    String(raw).split('~|~').forEach(function (v) {
      v = v.trim();
      if (v) inStock[v.toLowerCase()] = true;
    });
    if (!Object.keys(inStock).length) return;
    card.querySelectorAll('[data-size]').forEach(function (el) {
      var key = (el.getAttribute('data-size') || '').trim().toLowerCase();
      el.classList.toggle('is-disabled', !inStock[key]);
    });
  }
  function applySizes(card, sw) {
    if (sw) applySizesFromList(card, sw.getAttribute('data-sizes'));
  }
  /* in-stock sizes of a sibling colourway product, in the same shape the Liquid
     writes onto this product's own swatches */
  function sizesOf(p) {
    if (!p || !p.options || !p.variants) return null;
    var si = -1;
    p.options.forEach(function (o, i) {
      var name = (typeof o === 'string' ? o : (o && o.name)) || '';
      if (/size/i.test(name)) si = i;
    });
    if (si < 0) return null;
    var out = [];
    p.variants.forEach(function (v) {
      if (!v.available) return;
      var val = v.options && v.options[si];
      if (val && out.indexOf(val) < 0) out.push(val);
    });
    return out.join('~|~');
  }
  if (window.__psCardBooted) return;   /* three sections each load this file */
  window.__psCardBooted = true;
  var cache = {};

  function slugify(v) {
    return String(v || '').toLowerCase().trim()
      .replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* mirrors the shop's money format so a swapped card can restate its price */
  function money(cents) {
    var fmt = (window.psMoneyFormat || (window.theme && window.theme.moneyFormat) || '{{amount_no_decimals}}').replace(/<[^>]+>/g, '');
    var whole = Math.round(cents / 100).toLocaleString('en-IN');
    var withDec = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, whole)
              .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withDec);
  }

  function sizedTo(url, width) {
    if (!url) return url;
    return url.indexOf('?') > -1 ? url + '&width=' + width : url + '?width=' + width;
  }

  var WIDTHS = [300, 400, 500, 600, 800, 1000, 1200];
  function srcsetFor(bare) {
    return WIDTHS.map(function (w) { return sizedTo(bare, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* ---- image warming ------------------------------------------------------
     Tapping a swatch used to start the new image's download on the click, so the
     card sat on the old photo for as long as the network took. We now fetch the
     other colourways ahead of the tap.

     The decoy <img> carries the same srcset and sizes as the card's real <img>,
     so the browser picks the same candidate it will pick on the swap — which
     makes the swap a cache hit rather than a request. decode() also gets the
     bitmap ready, so the paint happens on the same frame as the tap. */
  var warm = {};                       /* bare url + '|' + sizes -> Promise */
  var queue = [];                      /* low-priority work, 3 at a time */
  var active = 0;
  var conn = navigator.connection || {};
  var thrifty = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  /* background warming is a guess, so it gets a budget; a swatch the shopper has
     actually reached for is never refused */
  var BUDGET = 40;
  var spent = 0;

  function warmImage(bare, sizes, eager) {
    if (!bare) return null;
    var key = bare + '|' + (sizes || '');
    if (warm[key]) return warm[key];
    if (!eager && spent >= BUDGET) return null;
    spent++;
    var run = function () {
      var img = new Image();
      try { img.fetchPriority = eager ? 'high' : 'low'; } catch (e) {}
      if (sizes) img.sizes = sizes;
      img.srcset = srcsetFor(bare);
      img.src = sizedTo(bare, 800);    /* only used if srcset is unsupported */
      var done = img.decode ? img.decode().catch(function () {}) : new Promise(function (res) {
        img.onload = img.onerror = res;
      });
      return done.then(function () { active--; drain(); });
    };
    if (eager) { active++; warm[key] = run(); return warm[key]; }
    warm[key] = new Promise(function (resolve) { queue.push(function () { resolve(run()); }); });
    drain();
    return warm[key];
  }
  function drain() {
    while (active < 3 && queue.length) { active++; queue.shift()(); }
  }

  /* warm every colourway on a card — cheap, because a card has at most four */
  function warmCard(card, eager) {
    if (thrifty && !eager) return;
    var main = card.querySelector('[data-ps-main-img], .ps-card__img--main');
    var sizes = main && main.getAttribute('sizes');
    card.querySelectorAll('[data-ps-swatch]').forEach(function (sw) {
      if (sw.dataset.image) warmImage(sw.dataset.image.split('?')[0], sizes, eager);
    });
  }

  /* cards that have been on screen for a moment are the ones worth warming */
  var seen = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) { clearTimeout(en.target.__psWarmT); return; }
      en.target.__psWarmT = setTimeout(function () {
        seen.unobserve(en.target);
        var go = function () { warmCard(en.target, false); };
        if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 1);
      }, 300);
    });
  }, { rootMargin: '150px 0px' }) : null;

  /* /products/<handle>.js 404s for some colourways (they sit outside this market's
     catalogue), so fall back to the suggest endpoint, which still returns them. */
  function fetchProduct(handle, title) {
    if (!(handle in cache)) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) {
          /* live: the product page itself is reachable, so it is safe to link to */
          if (p && p.featured_image) return { image: p.featured_image, url: p.url, live: true, title: p.title, price: p.price, sizes: sizesOf(p) };
          if (!title) return null;
          return fetch('/search/suggest.json?q=' + encodeURIComponent(title) +
              '&resources[type]=product&resources[limit]=10')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
              var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
              for (var i = 0; i < list.length; i++) {
                if (list[i].handle === handle) {
                  var img = list[i].featured_image || list[i].image;
                  if (img && img.url) img = img.url;
                  /* suggest lists colourways whose product page 404s — image only */
                  return img ? { image: img, url: list[i].url.split('?')[0], live: false, title: list[i].title, price: list[i].price } : null;
                }
              }
              return null;
            })
            .catch(function () { return null; });
        });
    }
    return cache[handle];
  }

  function bind(card) {
    if (card.dataset.psBound) return;
    card.dataset.psBound = '1';
    /* image_tag drops unknown data attributes, so fall back to the class */
    var main = card.querySelector('[data-ps-main-img], .ps-card__img--main');
    var hover = card.querySelector('.ps-card__img--hover');
    var links = card.querySelectorAll('.ps-card__media-link, .ps-card__title-link');
    var swatches = [].slice.call(card.querySelectorAll('[data-ps-swatch]'));
    if (!swatches.length) return;
    card.__psSwatchSeq = 0;

    var handle = card.dataset.handle || '';
    var original = { src: main && main.getAttribute('src'), srcset: main && main.getAttribute('srcset'), sizes: main && main.getAttribute('sizes') };
    var originalUrl = card.dataset.productUrl || (links[0] && links[0].getAttribute('href'));

    /* the colour this card was rendered for — the swatch whose slug ends the handle */
    var base = handle;
    swatches.forEach(function (sw) {
      var slug = slugify(sw.getAttribute('title'));
      if (slug && handle.slice(-(slug.length + 1)) === '-' + slug) base = handle.slice(0, -(slug.length + 1));
    });

    function show(src, url, title, price) {
      if (main && src) {
        var bare = src.split('?')[0];
        /* keep the image responsive instead of pinning one desktop-width file */
        main.srcset = srcsetFor(bare);
        /* the fallback src is only read when srcset is unsupported — asking for
           1200 here made slow devices pull a desktop file they never display */
        main.src = sizedTo(bare, 800);
        if (original.sizes) main.sizes = original.sizes;
        if (hover) hover.style.display = 'none';
        /* warmed images swap on this frame; a cold one fades rather than hanging
           on the previous colour with no sign that the tap registered */
        if (!main.complete) {
          main.classList.add('is-swapping');
          var clear = function () { main.classList.remove('is-swapping'); };
          if (main.decode) main.decode().then(clear, clear); else { main.onload = clear; main.onerror = clear; }
        }
      }
      if (url) links.forEach(function (a) { a.href = url; });
      /* the card now shows another product — its words have to follow */
      if (title) { var t = card.querySelector('.ps-card__title-link') || card.querySelector('.ps-card__title'); if (t) t.textContent = title; }
      if (price != null) { var p = card.querySelector('.ps-card__price'); if (p) p.textContent = money(price); }
    }

    var titleEl = card.querySelector('.ps-card__title-link') || card.querySelector('.ps-card__title');
    var priceEl = card.querySelector('.ps-card__price');
    var originalTitle = titleEl ? titleEl.textContent : null;
    var originalPrice = priceEl ? priceEl.textContent : null;
    function restore() {
      if (main) {
        if (original.src) main.setAttribute('src', original.src);
        if (original.srcset) main.setAttribute('srcset', original.srcset); else main.removeAttribute('srcset');
        if (original.sizes) main.setAttribute('sizes', original.sizes);
        main.classList.remove('is-swapping');
        if (hover) hover.style.display = '';
      }
      if (originalUrl) links.forEach(function (a) { a.href = originalUrl; });
      if (titleEl && originalTitle !== null) titleEl.textContent = originalTitle;
      if (priceEl && originalPrice !== null) priceEl.textContent = originalPrice;
    }

    /* the card is on screen: get its other colourways into the cache while the
       shopper is still looking at it, so the tap itself has nothing to wait for */
    if (seen) seen.observe(card);
    /* and the moment they reach for one, pull the rest in at full priority */
    var intent = function () { warmCard(card, true); };
    card.addEventListener('pointerenter', intent, { once: true, passive: true });
    card.addEventListener('touchstart', intent, { once: true, passive: true });

    swatches.forEach(function (sw) {
      var reach = function () {
        if (sw.dataset.image) warmImage(sw.dataset.image.split('?')[0], original.sizes, true);
        var s = slugify(sw.getAttribute('title'));
        var sib = base && s ? base + '-' + s : '';
        if (sib && sib !== handle && !sw.dataset.image) fetchProduct(sib, originalTitle && originalTitle.trim());
      };
      sw.addEventListener('pointerenter', reach, { once: true, passive: true });
      sw.addEventListener('touchstart', reach, { once: true, passive: true });

      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        swatches.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
        sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
        applySizes(card, sw);

        var slug = slugify(sw.getAttribute('title'));
        var sibling = base && slug ? base + '-' + slug : '';
        var token = ++card.__psSwatchSeq;

        /* this card's own colour — put the original imagery back */
        if (sibling === handle) { restore(); return; }

        /* a variant image on this product wins, when the merchant has set one */
        if (sw.dataset.image && sw.dataset.image !== original.src) {
          show(sw.dataset.image, sw.dataset.url || originalUrl);
          return;
        }

        if (!sibling) { if (sw.dataset.url) show(null, sw.dataset.url); return; }
        fetchProduct(sibling, originalTitle && originalTitle.trim()).then(function (p) {
          /* a slower earlier click must not paint over the colour now selected */
          if (token !== card.__psSwatchSeq) return;
          applySizesFromList(card, p && p.sizes);
          /* The variant URL on this product is always a live page; a sibling handle
             is only safe to link to when its own product page answered. */
          var href = sw.dataset.url || (p && p.live ? p.url : originalUrl);
          if (p && p.image) show(p.image, href, p.title, p.price);
          else show(sw.dataset.image || null, href);
        });
      });
    });
  }

  /* Quick add (ps-quick.js) lists colours as names. Turn that row into swatch chips using the
     card's own swatch colours; the buttons, their data and ps-quick's click handling are untouched. */
  var COLOUR_LABEL = /^(colou?r|shade)$/i;
  function swatchQuickPanel(panel) {
    var card = panel.closest('.ps-card');
    if (!card) return;
    var chips = {};
    card.querySelectorAll('.ps-swatch[title]').forEach(function (sw) {
      var c = sw.querySelector('.ps-swatch__color');
      if (c && c.style.background) chips[sw.title.trim().toUpperCase()] = c.style.background;
    });
    panel.querySelectorAll('.ps-quick__group').forEach(function (group) {
      var label = group.querySelector('.ps-quick__label');
      if (!label || !COLOUR_LABEL.test(label.textContent.trim())) return;
      var values = group.querySelector('.ps-quick__values');
      group.querySelectorAll('.ps-quick__value').forEach(function (btn) {
        if (btn.classList.contains('ps-quick__value--swatch')) return;
        var name = btn.textContent.trim();
        var bg = chips[name.toUpperCase()];
        if (!bg) return;                       /* no known colour: leave the name showing */
        btn.classList.add('ps-quick__value--swatch');
        btn.setAttribute('aria-label', name);
        btn.setAttribute('title', name);
        btn.textContent = '';
        var chip = document.createElement('span');
        chip.className = 'ps-quick__chip';
        chip.style.background = bg;
        var txt = document.createElement('span');
        txt.className = 'visually-hidden';
        txt.textContent = name;
        btn.appendChild(chip); btn.appendChild(txt);
      });
      if (values) values.classList.add('ps-quick__values--swatches');
    });
  }
  function watchQuickPanels(root) {
    (root || document).querySelectorAll('[data-ps-quickpanel]').forEach(function (panel) {
      if (panel.__psQuickObs) return;
      panel.__psQuickObs = new MutationObserver(function () { swatchQuickPanel(panel); });
      panel.__psQuickObs.observe(panel, { childList: true, subtree: true });
      swatchQuickPanel(panel);
    });
  }

  function init(root) { (root || document).querySelectorAll('[data-ps-card]').forEach(bind); watchQuickPanels(root); }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.psCardInit = init;
})();
